// src/components/Programacion/validators.js
export function validarCampos({ tipoNuevo, nuevoProg, sectoresSeleccionados, duracionComun }) {
  const errors = {};
  if (tipoNuevo === "semanal" && !nuevoProg.startTime) errors.startTime = true;
  if (tipoNuevo === "diaria"  && !nuevoProg.cyclicStartTime) errors.cyclicStartTime = true;
  if (tipoNuevo === "semanal" && (!nuevoProg.cyclesPerDay || nuevoProg.cyclesPerDay < 1))
    errors.cyclesPerDay = true;
  if (tipoNuevo === "diaria"  && (!nuevoProg.cyclicCyclesPerDay || nuevoProg.cyclicCyclesPerDay < 1))
    errors.cyclicCyclesPerDay = true;
  if (tipoNuevo === "semanal" && !nuevoProg.intervalTime) errors.intervalTime = true;
  if (tipoNuevo === "diaria"  && !nuevoProg.cyclicIntervalTime) errors.cyclicIntervalTime = true;
  if (tipoNuevo === "semanal" && (!nuevoProg.days || nuevoProg.days.length === 0))
    errors.days = true;

  // Validación de duración por sector o global
  if (sectoresSeleccionados.length > 0) {
    if (duracionComun.trim() !== "") {
      if (!/^\d{2}:\d{2}$/.test(duracionComun.trim()))
        errors.duracionComun = true;
    } else {
      sectoresSeleccionados.forEach((sector) => {
        if (!sector.duracionComunSector ||
            !/^\d{2}:\d{2}$/.test(sector.duracionComunSector.trim())
        ) {
          errors[`sector_${sector.sectorId}`] = true;
        }
      });
    }
  }

  return errors;
}
